export const USER_LIST_START = 'USER_LIST_START';
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS';
export const USER_LIST_FAIL = 'USER_LIST_FAIL';

export const USER_INVITE_START = 'USER_INVITE_START';
export const USER_INVITE_SUCCESS = 'USER_INVITE_SUCCESS';
export const USER_INVITE_FAIL = 'USER_INVITE_FAIL';

export const REPEAT_USER_INVITE_START = 'REPEAT_USER_INVITE_START';
export const REPEAT_USER_INVITE_SUCCESS = 'REPEAT_USER_INVITE_SUCCESS';
export const REPEAT_USER_INVITE_FAIL = 'REPEAT_USER_INVITE_FAIL';

export const USER_BY_ID_START = 'USER_BY_ID_START';
export const USER_BY_ID_SUCCESS = 'USER_BY_ID_SUCCESS';
export const USER_BY_ID_FAIL = 'USER_BY_ID_FAIL';

export const DEACTIVATE_USER_START = 'DEACTIVATE_USER_START';
export const DEACTIVATE_USER_SUCCESS = 'DEACTIVATE_USER_SUCCESS';
export const DEACTIVATE_USER_FAIL = 'DEACTIVATE_USER_FAIL';

export const ACTIVATE_USER_START = 'ACTIVATE_USER_START';
export const ACTIVATE_USER_SUCCESS = 'ACTIVATE_USER_SUCCESS';
export const ACTIVATE_USER_FAIL = 'ACTIVATE_USER_FAIL';

export const USER_UPDATE_START = 'USER_UPDATE_START';
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS';
export const USER_UPDATE_FAIL = 'USER_UPDATE_FAIL';

export const UPLOAD_USER_LOGO_START = 'UPLOAD_USER_LOGO_START';
export const UPLOAD_USER_LOGO_SUCCESS = 'UPLOAD_USER_LOGO_SUCCESS';
export const UPLOAD_USER_LOGO_FAIL = 'UPLOAD_USER_LOGO_FAIL';

export const USER_LOGIN_START = 'USER_LOGIN_START';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';

export const USER_CONFIRM_REST_PASS_START = 'USER_CONFIRM_REST_PASS_START';
export const USER_CONFIRM_REST_PASS_SUCCESS = 'USER_CONFIRM_REST_PASS_SUCCESS';
export const USER_CONFIRM_REST_PASS_FAIL = 'USER_CONFIRM_REST_PASS_FAIL';

export const USER_CONFIRM_REGISTRATION_START = 'USER_CONFIRM_REGISTRATION_START';
export const USER_CONFIRM_REGISTRATION_SUCCESS = 'USER_CONFIRM_REGISTRATION_SUCCESS';
export const USER_CONFIRM_REGISTRATION_FAIL = 'USER_CONFIRM_REGISTRATION_FAIL';
